import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    try {
      const submitAddr = 'https://readdy.ai/api/form/d9ot9j0senbnioleslg0';
      const res = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email, 'phone_alt': '' }).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们将为您推送最新韩漫更新资讯。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        if (serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('订阅失败，请稍后重试');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            订阅更新通知
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            第一时间获取最新韩漫上线通知和热门推荐，不错过任何精彩内容
          </p>

          <form
            onSubmit={handleSubmit}
            data-readdy-form=""
            className="mt-8 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="请输入您的邮箱地址"
              required
              className="w-full sm:flex-1 px-5 py-3 text-sm rounded-full bg-background-50 border border-background-200/70 text-foreground-700 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="website-alt-field"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="whitespace-nowrap w-full sm:w-auto px-6 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 disabled:opacity-60 transition-all duration-200"
            >
              {status === 'loading' ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  订阅中
                </span>
              ) : (
                '立即订阅'
              )}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-green-600">{message}</p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-sm text-red-500">{message}</p>
          )}
        </div>
      </div>
    </section>
  );
}